import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import * as S from './styled';

const ReturnOfferMessage = () => {
    const { t } = useTranslation();

    return (
        <S.ReturnOfferContainer>
            <S.ReturnOfferHeading>
                <S.StyledIcon />
                <Text type="large-text" medium>
                    {t('subscription.cancelledCard.info.title')}
                </Text>
            </S.ReturnOfferHeading>
            <Text>{t('subscription.returnOfferMessage.body')}</Text>
        </S.ReturnOfferContainer>
    );
};

export default ReturnOfferMessage;
